<template>
  <iframe style="width: 100%; height: 100%; padding-bottom: 50px;"
  src="/help/index.html"/>
</template>

<script>
export default {
  name: 'CommerciaVueHelp',
  data () {
    return {}
  }
}
</script>
